import { connect } from 'react-redux';
import QuestionScreen from './screen';
import {
  submit_unlocked_achievement,
  achievement_unlocked,
} from '../../../../redux/actions/AchievementActions';
import {
  submitTestResponse,
  backTo_Topics,
  hideQuestion,
  getQuestionByTopicId,
} from '../../../../redux/actions/QuestionActions';

const mapStateToProps = (state) => {
  return {
    state,
    loading: state.LoadingReducer.isLoading,
    userId: state.CommonReducer.userId,
    purchaseStatus: state.CommonReducer.purchaseStatus,
    sessionToken: state.CommonReducer.sessionToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getQuestionByTopicId: (questionBody, questionId, errorSnackbar) =>
      dispatch(getQuestionByTopicId(questionBody, questionId, errorSnackbar)),

    submitTestResponse: (testResponseData, back, callback) =>
      dispatch(submitTestResponse(testResponseData, back, callback)),

    hideQuestion: (testResponseData, callback) =>
      dispatch(hideQuestion(testResponseData, callback)),
    achievement_unlocked: (achievement_key, value) =>
      dispatch(achievement_unlocked(achievement_key, value)),

    backTo_Topics: () => dispatch(backTo_Topics()),
    submit_unlocked_achievement: (submit_data) =>
      dispatch(submit_unlocked_achievement(submit_data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionScreen);
